(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        if (!this.header) return;

        this.isStaticLight = this.classList.contains('header--static-light');
        this.setHeaderHeight = this.setHeaderHeight.bind(this);
        this.setHeaderHeight();

        this.mediaQuery = window.matchMedia('(max-width: 990px)');
        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.setHeaderHeight);
        } else if (this.mediaQuery.addListener) {
          this.mediaQuery.addListener(this.setHeaderHeight);
        }

        if (this.isStaticLight) return;

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.onScroll();
      }

      setHeaderHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        if (this.onScrollHandler) {
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        if (this.mediaQuery) {
          if (this.mediaQuery.removeEventListener) {
            this.mediaQuery.removeEventListener('change', this.setHeaderHeight);
          } else if (this.mediaQuery.removeListener) {
            this.mediaQuery.removeListener(this.setHeaderHeight);
          }
        }
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.header.classList.toggle('scrolled-past-header', scrollTop > 10);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
